import React from 'react'

const InputShadow = ({ name, value, placeholder, onChange, maxlength  }) => {
    return (
        <div className="input-group rounded-pill shadow mt-3">  
            <span 
                className="bg-white border-0 rounded-pill" 
                style={{ marginLeft:'1rem', paddingTop:'0.2rem'}}
            >
            </span>
            <input 
                type="text" 
                className='form-control border-0' 
                value={value} 
                name={name} 
                onChange={onChange} 
                placeholder={placeholder} 
                maxlength={maxlength ? maxlength : null}
                />
            <span 
                className="bg-white border-0 rounded-pill" 
                style={{ marginRight:'1rem', paddingTop:'0.2rem', height:20, width:20 }}
            >
            </span>
        </div>
    )
}

export default InputShadow 

/*

        <div className='mt-3'>
            <input type="text" className='form-control border-0 rounded-pill shadow' value={value} name='nameStaff' onChange={onChange} placeholder={placeholder} />
        </div>

*/